var map = {
	"./bottom_tab_b.wav": 8360,
	"./card_grab_version1.wav": 4149,
	"./card_grab_version2.wav": 2266,
	"./card_grab_version3.wav": 6275,
	"./card_place_version1.wav": 9350,
	"./card_place_version2.wav": 49,
	"./card_place_version3.wav": 2584,
	"./cards_out_start.wav": 1039,
	"./cash_win_long_out.wav": 6504,
	"./cash_win_short_in.wav": 1807,
	"./cash_win_short_out.wav": 2034,
	"./close_b.wav": 8073,
	"./collect_card_version1.wav": 6913,
	"./collect_card_version2.wav": 5174,
	"./collect_card_version3.wav": 3055,
	"./error.wav": 6388,
	"./game_over.wav": 1093,
	"./magic_time.wav": 6065,
	"./next_1_card.wav": 9026,
	"./next_2_cards.wav": 8330,
	"./next_3_cards_version1.wav": 6939,
	"./next_3_cards_version2.wav": 4004,
	"./next_3_cards_version3.wav": 9757,
	"./next_b.wav": 5830,
	"./play_b.wav": 231,
	"./score_run.wav": 5578,
	"./score_run_out.wav": 8839,
	"./submit.wav": 18,
	"./swish_in.wav": 8458,
	"./swish_out.wav": 9065
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2410;